import React, { useEffect, useState } from "react";
import SimpleSelect from "../SimpleSelect";
import { useDispatch } from "react-redux";
import {
  getFollowListSetup,
  getIndustryData,
  getReport,
  getReportData,
  getSideBarData,
  getTrackingList,
  getTriggerData,
  getTriggerList,
  getTriggerReport,
  saveTriggers,
} from "../../redux/actions/intentAction";
import { useSelector } from "react-redux";
import Select from "react-tailwindcss-select";
import Loading from "../assetLibComponents/Loading";
import Jump from "../../assets/zoiJump.gif";
import Nike from "../../assets/nikeLogo.svg";
import Logo from "../../assets/Vector.svg";
import { IoFunnelOutline } from "react-icons/io5";
import { IoIosSearch } from "react-icons/io";
import { CiSettings } from "react-icons/ci";
import * as Icon from "react-bootstrap-icons";
import { FaLinkedin, FaStar } from "react-icons/fa";
import { MdOutgoingMail } from "react-icons/md";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { postRemoveStar, postStar } from "../../redux/actions/accountAction";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router";
import { DebounceInput } from "react-debounce-input";
import { MultiSelect } from "react-multi-select-component";
import Toast from "../assetLibComponents/shared/Toast";



const IntelSetting = (props) => {
  props.pageTypeHandler("Intel");
  let navigate = useNavigate();

  const [sidebar, setSidebar] = useState(true);
  const [sidebarToggle, setSidebarToggle] = useState("Setup");
  const [searchCompany, setSearchCompany] = useState("");
  const [searchIndustry, setSearchIndustry] = useState("");
  const [triggerValue, setTriggerValue] = useState("");
  const [aboutClient, setAboutClient] = useState("");
  const [productOffering, setProductOffering] = useState("");
  const [freshnessSelected, setFreshnessSelected] = useState({
    id: 1,
    name: "Day",
  });
  const [articleNumber, setArticleNumber] = useState("");
  const [selectedC,setSelectedC]=useState({ id: 1, name: "Company" });
  const [calendarTrigger, setCalendarTrigger] = useState([]);
  const [selected, setSelected] = useState([]);
  const [newArr, setNewArr] = useState([]);
  const [pError, setPError] = useState("");
  const [selectedTrigger, setSelectedTrigger] = useState([]);
  const [selectedPlayTrigger, setSelectedPlayTrigger] = useState([]);
  const [editState, setEditState] = useState(false);
  const [compSolution, setCompSolution] = useState("");
  const [compProducts, setCompProducts] = useState("");
  const [compCertificates, setCompCertificates] = useState("");
  const [compCase, setCompCase] = useState("");
  const [compFocus, setCompFocus] = useState("");


  const [formData, setFormData] = useState({
    targetCompany: "",
    aboutSeller: "",
    aboutOffering: "",
    // articleNumber:"",
    triggers: "",
  });
  const dispatch = useDispatch();
  const tList = useSelector((state) => state.intent?.triggerList);
  const aData = useSelector((state) => state?.assetLibrary?.userData);
  const iData = useSelector((state) => state.intent?.industryData);
  const tData = useSelector((state) => state.intent?.triggerData);
  const tReport = useSelector((state) => state.intent?.triggerReport);
  const fList = useSelector((state) => state.intent?.followListSetup);
  const repId = useSelector((state) => state.intent?.reportId?.report_id);
  const repData = useSelector(
    (state) => state.intent?.reportData?.data?.articles_report
  );
  const repStatus = useSelector((state) => state.intent?.reportDataMore);
  const isLoading = useSelector((state) => state.intent.loading);
  const trackList = useSelector((state) => state.intent.trackingList);
  const uData = JSON.parse(localStorage.getItem("userData"));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    dispatch(getIndustryData(props.authToken));
    dispatch(getTriggerData(props.authToken));
    dispatch(getTriggerList(props.authToken));
    dispatch(getFollowListSetup(props.authToken));
    dispatch(getTrackingList(props.authToken,"",""));
    dispatch({ type: "TRIGGER_REPORT", payload: null });
  }, [sidebarToggle]);

  function convertArray(arr) {
    return arr?.map(item => ({
        value: item.value,
        label: item.value
    }));
} 
  useEffect(() => {
    if (tList?.statusCode == "200") {
      setFormData({
        aboutSeller: tList?.details?.about_company,
        aboutOffering: tList?.details?.company_offerings,
        triggers: tList?.details?.triggers,
      });
      setSelectedPlayTrigger(tList?.details?.triggers)
      // setSelectedTrigger(tData?.used_triggers)
      setSelectedTrigger(tList?.details?.triggers)
      setAboutClient(tList?.details?.about_company)
      setProductOffering(tList?.details?.company_offerings)
      setCompSolution(tList?.details?.competency_profile?.data?.solutions?.join(","))
      setCompProducts(tList?.details?.competency_profile?.data?.products?.join(","))
      setCompCertificates(tList?.details?.competency_profile?.data?.certification_and_awards?.join(","))
      setCompCase(tList?.details?.competency_profile?.data?.clients_case_studies?.join(","))
      setCompFocus(tList?.details?.competency_profile?.data?.focus_industries?.join(","))
    }
    if(iData?.list?.length > 0){
      const outputArray = convertArray(iData?.list);
      setNewArr(outputArray);
  }
  if(uData?.data?.intent == false){
    navigate(`/Chat-Ai`)
  }
  //   if(tData?.list?.length > 0){
  //     const orray = convertArray(tData?.data);
  //     setTriggerArr(orray);
  // }
  }, [tList]);

  // console.log(triggerArr,"tdata")

  function extractValues(arr) {
    return arr.map(item => item.label);
}

  const handleTestIntel = () =>{
    const outputArray = extractValues(selected);
    const oArray = extractValues(selectedPlayTrigger);
    const payload ={
    industry_or_company_name:outputArray,
    triggers: oArray.join(","),
    about_company:formData?.aboutSeller,
    company_offerings:formData?.aboutOffering,
    is_company:false
    }
    if(outputArray.length > 0 && oArray.length > 0){
      dispatch(getTriggerReport(props.authToken,payload));
      dispatch({ type: "TRIGGER_REPORT", payload: null });
      setMessages([])
    }else{
      Toast("Please select Industry/Trigger to generate report", "E");
    }


  }
  const convertToArray = (str) => {
    return str.split(',').map(item => item.trim());
  };

  const handleSelectChange = (selectedOptions) => {
    if (selectedOptions?.length <= uData?.data?.industry) {
      setSelected(selectedOptions);
    }};
  const handleTriggerChange = (selectedOptions) => {
    if (selectedOptions?.length <= uData?.data?.triggers) {
      setSelectedTrigger(selectedOptions);
    }else {
      setPError("You have reached the maximum number of triggers allowed for this plan.")
  }
  };
  
  const handlePlayTriggerChange = (selectedOptions) => {
    if (selectedOptions?.length <= uData?.data?.triggers) {
      setSelectedPlayTrigger(selectedOptions);
    }
  };
  
  const handleSaveIntel = () =>{
    const outputArray = extractValues(selectedTrigger);
    const payload ={
    // industry_or_company_name:formData?.targetCompany,
    triggers: outputArray?.join(','),
    about_company:aboutClient,
    company_offerings:productOffering,
    competency_profile:{
      products:compProducts?.split(','),
      solutions:compSolution?.split(','),
      focus_industries:compFocus?.split(","),
      certification_and_awards:compCertificates?.split(","),
      clients_case_studies:compCase?.split(",")
  }
    }
    dispatch(saveTriggers(props.authToken,payload));
    navigate(`/Intel`)
    uData.set_intent = true;
    localStorage.setItem('userData', JSON.stringify(uData));
  };
     

  const handlefollow=(id,type) => {
    let str = id.toString();
    if(type == "company" && fList?.details?.company?.length < uData?.data?.company){
      dispatch(postStar(props.authToken,[str],type,"track"));
    }else if(type == "industry" && fList?.details?.industry?.length < uData?.data?.industry){
      dispatch(postStar(props.authToken,[str],type,"track"));
    }else{
      if(type == "company"){
        setPError("You are following the maximum number of companies allowed for this plan.")
      }else{
        setPError("You are following the maximum number of industries allowed for this plan.")
      }
    }
    // dispatch(postRemoveStar(props.authToken,[str]));

  };

  const handleunfollow=(id,type) => {
    let str = id.toString();
    // dispatch(postStar(props.authToken,[str],"track"));
    dispatch(postRemoveStar(props.authToken,[str],type,"track"));

  };

  const selectTimeline = [
    { id: 1, name: "Company" },
    { id: 2, name: "Industry" },
  ];

  const handleSearchCompany = (e) =>{
    setSearchCompany(e.target.value)
    dispatch(getTrackingList(props.authToken,e.target.value,"company"));
  }
  const handleSearchIndustry = (e) =>{
    setSearchIndustry(e.target.value)
    dispatch(getTrackingList(props.authToken,e.target.value,"industry"));
  }

  const handleTrigger = (event) => {
    if(event?.nativeEvent?.data === "Enter"){
      setTriggerValue("")
    }else{
      setTriggerValue(event.target.value)
    }
    };


  const handleKeyDown = (event) => {
    if ((event.key === 'Enter') && triggerValue.trim() !== '') {
      if (calendarTrigger?.length < uData?.data?.triggers) {
        setCalendarTrigger([...calendarTrigger, triggerValue.trim()]); // Add input value to array
        setTriggerValue(''); // Clear input field
    } else {
        // Optionally, you can handle the case when the limit is reached, e.g., show a message
        setPError(true)
    }
    }
  };

  const handleClose = (index) =>{
    setCalendarTrigger(calendarTrigger.filter((_, i) => i !== index));
  }


  const [messages, setMessages] = useState([]);

  useEffect(() => {
      const socket = new WebSocket(`wss://staging1.askzoi.com/intent_report_stream/${aData?.new_client_id}/`);

      // Connection opened
      socket.addEventListener('open', function (event) {
        console.log('WebSocket connected');
      });
  
      // Listen for messages
      socket.addEventListener('message', function (event) {
          const data =JSON.parse(event.data);
          setMessages(data)
          });
  
      // Error handling
      socket.addEventListener('error', function (error) {
          console.error('WebSocket encountered error:', error);
      });
  
  }, []);


  console.log(compSolution,"compSol")

  return (
    <div className="w-full flex">
              {isLoading &&  <>
      <div className="lds-dual-ring"></div>
      <div className="overlay-bg"></div>
    </>}
      <div className="w-[20%] h-[100vh]">
        <div className="pt-20">
          <div className="flex justify-between px-6 my-3">
            <div className="text-lg font-[600] my-auto">Intel/Settings</div>
            <div className="flex gap-x-5 my-auto">
              {/* <IoFunnelOutline className="text-lg text-gray-400 my-auto" /> */}
              {/* <IoIosSearch className="text-xl text-gray-400 my-auto" /> */}
              {/* <CiSettings  /> */}
              <IoClose onClick={()=>{navigate(`/Intel`)}} className="text-2xl cursor-pointer text-gray-400 my-auto"/>

            </div>
          </div>
          <div className=" text-black flex text-base gap-x-8 px-8 pt-3 cursor-pointer">
            <div
              className={`${
                sidebarToggle == "Setup"
                  ? "text-black border-solid border-b-2 border-[var(--brand-primary)]"
                  : "text-gray-400"
              } pb-3`}
              onClick={() => {
                setSidebarToggle("Setup");
                window.location.reload();
              }}
            >
              Playground
            </div>
            <div
              className={`${
                sidebarToggle == "Tracking"
                  ? "text-black border-solid border-b-2 border-[var(--brand-primary)]"
                  : "text-gray-400"
              } pb-3`}
              onClick={() => {
                setSidebarToggle("Tracking");
              }}
            >
              Setup
            </div>
          </div>
        </div>
        {sidebarToggle == "Setup" && (
          <div className="flex-col px-6 ">
            <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
              <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                Triggers
              </label>
              <div className="flex">
              {tData?.data?.length > 0  &&<MultiSelect
        options={tData?.data}
        value={selectedPlayTrigger}
        onChange={handlePlayTriggerChange}
        labelledBy="Select"
        className='w-full !border-0'
        hasSelectAll={false}
      />}
                {/* <input
                  type="text"
                  name="triggers"
                  value={formData.triggers}
                  onChange={handleChange}
                  className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter Text Here"
                /> */}
              </div>
            </div>
           
            <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
            <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                Industry
              </label>
              <div className="flex w-full">
              {newArr?.length > 0 && <MultiSelect
        options={newArr}
        value={selected}
        onChange={handleSelectChange}
        labelledBy="Select"
        className='w-full border-0'
        hasSelectAll={false}
      />}
              </div>
            </div>
            <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
              <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                About the Client
              </label>
              <div className="flex">
                <input
                  type="text"
                  name="aboutSeller"
                  value={formData.aboutSeller}
                  onChange={handleChange}
                  className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter Text Here"
                />
              </div>
            </div>
            <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
              <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                Products/Offering
              </label>
              <div className="flex">
                <input
                  type="text"
                  name="aboutOffering"
                  value={formData.aboutOffering}
                  onChange={handleChange}
                  className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter Text Here"
                />
              </div>
            </div>
            <div className="flex">
            {<button
              type="button"
              className={`${!repStatus ? "bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)]" : "bg-gray-400"} mt-4 ml-auto inline-flex items-center gap-x-1.5 rounded-md border-solid border-2  text-white px-3 py-2 text-sm font-semibold shadow-sm`}
              onClick={()=>{!repStatus && handleTestIntel()}}
            >
              Test
            </button>}
          </div>
            {/* <div onClick={handleSubmit} className="bg-[#49BCD2] text-white p-2 rounded-md w-[20%] ml-auto text-xl my-auto text-center cursor-pointer">{`->`}</div>        */}
          </div>
        )}
        {sidebarToggle == "Tracking" && (
          <div className="flex-col px-6">
            <div>
              <hr />
              <div className="text-sm text-gray-400 my-4">Companies</div>
              <div className="text-sm text-gray-400 mb-4 border-solid border-2 border-gray-200 rounded-md flex justify-between">
              <DebounceInput
                value={searchCompany}
                className="border-none focus:ring-0 py-[6px] placeholder:text-gray-200 text-black"
                placeholder="Search Company..."
                minLength={3}
                debounceTimeout={500}
                onChange={handleSearchCompany}
              />
                {/* <input
                  type="text"
                  placeholder="Add Companies from CRM"
                  className="border-none focus:ring-0 py-[6px] placeholder:text-gray-200 text-black"
                /> */}
                <HiMagnifyingGlass className="my-auto mr-2 text-lg" />
              </div>

              <div className="overflow-y-auto h-[25vh] removeScroll">
                {trackList?.details?.companies?.map((item, index) => {
                  return (
                    <div className="flex mb-4">
                      <img className="w-7 h-7 my-auto text-base" src={item?.logo ?? Logo} />
                      <div className="my-auto ml-3">{item?.company_website}</div>
                      {item?.follow && <FaStar
                        className={`text-blue-400 my-auto text-xs cursor-pointer ml-2`}
                      />}
                      {!item?.follow && <div onClick={()=>{handlefollow(item?.id,"company")}} className="flex ml-auto my-auto text-xs font-bold cursor-pointer">Follow</div>}
                      {item?.follow && <div  onClick={()=>{handleunfollow(item?.id,"company")}} className="flex ml-auto my-auto text-lg mr-[1px] cursor-pointer">x</div>}
                    </div>
                  );
                })}
              </div>
            </div>
            <hr />

            <div className="text-sm text-gray-400 my-4">Industries</div>
            <div className="text-sm text-gray-400 mb-4 border-solid border-2 border-gray-200 rounded-md flex justify-between">
            <DebounceInput
                value={searchIndustry}
                className="border-none focus:ring-0 py-[6px] placeholder:text-gray-200 text-black"
                placeholder="Search Industry..."
                minLength={3}
                debounceTimeout={500}
                onChange={handleSearchIndustry}
              />
              <HiMagnifyingGlass className="my-auto mr-2 text-lg" />
            </div>
            <div className="overflow-y-auto h-[18vh] removeScroll">
              {trackList?.details?.industries?.map((item, index) => {
                return (
                  <div className="flex mb-4">
                    <img className="w-7 h-7 my-auto text-base" src={item?.logo ?? Logo} />
                    <div className="my-auto ml-3 font-[600]">
                      {item?.option_value}
                    </div>
                    {item?.follow && <FaStar className={`text-blue-400 my-auto text-xs cursor-pointer ml-2`}/>}
                    {!item?.follow && <div onClick={()=>{handlefollow(item?.option_value,"industry")}} className="flex ml-auto my-auto text-xs font-bold cursor-pointer">Follow</div>}
                      {item?.follow && <div  onClick={()=>{handleunfollow(item?.option_value,"industry")}} className="flex ml-auto my-auto text-lg mr-[1px] cursor-pointer">x</div>}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      {sidebarToggle == "Setup" && <div className="pt-20 w-[80%] bg-[#f3f4f6] overflow-y-auto h-[99vh] px-20">
        <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
          <div className="text-lg leading-7 font-[500] my-auto">Testing Playground</div>
        </div>
        <div>
        {repStatus && (!messages?.is_writing) && (!messages?.articles_report?.length > 0) && <div className="flex justify-center"><img src={Jump} className="w-48 h-48 mt-48 "/></div>}

          {!tReport?.articles_report && !repStatus && !messages?.is_writing && <div className="text-xl pt-48 mx-auto flex justify-center">Please complete setup to generate report.</div>}
          {tReport?.articles_report?.length == 0 && !repStatus && !messages?.is_writing && <div className="text-xl pt-48 mx-auto flex justify-center">No relevant Signals were found. Please check back again tomorrow!</div>}
         {tReport?.articles_report && !repStatus && tReport?.articles_report.map((item) => {
            return (
          <main className="p-4 space-y-4 !w-full">
            <div className="bg-white px-10 py-9 shadow rounded-xl">
              <div className="flex justify-between">
              <div className="text-gray-400 ">{item?.human_date}</div>
              <div className="rounded-md bg-yellow-100 text-yellow-500 px-2 py-1 max-sm:text-sm max-sm:mb-3">{item?.report_meta_data?.target}</div>
              </div>
              <div onClick={()=>window.open(item?.sourceUrl, "_blank")} className="text-xl leading-7 font-semibold mb-6 cursor-pointer">
                {item?.title}
              </div>
              <div className='flex gap-4 flex-wrap mb-4'>
               {item?.triggers_its_relevant_to?.map((tItem) => {
            return (
              <div className="rounded-md capitalize bg-yellow-100 text-yellow-500 px-2 py-1 max-sm:text-sm max-sm:mb-3">{tItem}</div>
            )})}
               {item?.companies_name_mentioned_in_news?.map((tItem) => {
            return (
              <div className="rounded-md bg-[#ECFEFF] text-cyan-500 px-2 py-1 max-sm:text-sm max-sm:mb-3">{tItem}</div>
            )})}
              </div>
              {/* <div className="text-gray-400">Summary</div>
              <div className="text-black">
                <p>
                  {item?.summary}
                </p>
              </div> */}
              <div className="pr-6 flex pl-4 mt-8">
                <img
                  src={Logo}
                  alt="BotIcon"
                  className="mb-auto mr-2 w-10 h-10"
                />
                <div className="first-left-response ml-4 !bg-[var(--brand-primary)] !w-full">
                  <Icon.CaretRightFill
                    className="left-icon-triangle-conversation"
                    color="var(--brand-primary)"
                  />
                  <p className="ai-heading text-white">SIA Says</p>
                  <p className="ai-response !text-white">
                    {item?.relevance}
                  </p>
                </div>
              </div>

              {<div className="mt-6">
            <div className="mb-2 text-gray-400">Talking Points</div>
           {/* {item?.action_items?.success_metrics?.length > 0 &&  <>
            <div className="list-decimal text-sm font-bold mb-1">
           B. Success Metrics
            </div>
            <div className="list-decimal text-sm ml-4">
            {item?.action_items?.success_metrics?.map((action) => {
            return (
              <li>{action}</li>
            )})}
            </div>
            </>} */}
            {item?.action_items?.clear_value_proposition?.length > 0 &&<>
            <div className="list-decimal text-sm font-bold mb-1">
           A. Value Proposition
            </div>
            <div className="list-decimal text-sm ml-4">
            {item?.action_items?.clear_value_proposition?.map((action) => {
            return (
              <li>{action}</li>
            )})}
            </div>
            </>}
            {item?.action_items?.tailored_outreach_strategy?.length > 0 && <>
            <div className="list-decimal text-sm font-bold mb-1">
           B. Outreach Strategy
            </div>
            <div className="list-decimal text-sm ml-4">
            {Array.isArray(item?.action_items?.tailored_outreach_strategy) ? item?.action_items?.tailored_outreach_strategy?.map((action) => {
            return (
              <li>{action}</li>
            )}):item?.action_items?.tailored_outreach_strategy}
            </div>
            </>}
        </div>}  

              {/* <hr className="my-8" />
              <div className="text-gray-400 mb-3">Relevant Leads</div>
              <div className="flex">
                <div className="border-solid border-gray-100 border-2 rounded-md py-2 px-2 flex justify-between">
                  <div className="rounded-full bg-yellow-100 p-3 text-yellow-500 text-lg">
                    AG
                  </div>
                  <div className="flex-col ml-3 my-auto">
                    <div className="font-[600] text-sm">Akash Guha</div>
                    <div className="font-[400] text-xs">
                      akashguha@gmail.com
                    </div>
                  </div>
                  <div className="flex gap-x-2 my-auto ml-3 text-gray-400">
                    <MdOutgoingMail className="text-2xl" />
                    <FaLinkedin className="text-lg my-auto" />
                  </div>
                </div>
              </div> */}
            </div>
          </main>
            )})}

          {(!tReport?.articles_report?.length > 0) && messages?.articles_report?.map((item) => {
                      return (
          <main className="p-4 space-y-4 !w-full">
            <div className="bg-white px-10 py-9 shadow rounded-xl">
            <div className="flex justify-between">
              <div className="text-gray-400 ">{item?.human_date}</div>
              <div className="rounded-md bg-yellow-100 text-yellow-500 px-2 py-1 max-sm:text-sm max-sm:mb-3">{item?.report_meta_data?.target}</div>
              </div>
              <div onClick={()=>window.open(item?.sourceUrl, "_blank")} className="text-xl leading-7 font-semibold mb-6 cursor-pointer">
                {item?.title}
              </div>
              <div className='flex gap-4 flex-wrap mb-4'>
               {item?.triggers_its_relevant_to?.map((tItem) => {
            return (

              <div className="rounded-md capitalize bg-yellow-100 text-yellow-500 px-2 py-1 max-sm:text-sm max-sm:mb-3">{tItem}</div>
            )})}
               {item?.companies_name_mentioned_in_news?.map((tItem) => {
            return (
              <div className="rounded-md bg-[#ECFEFF] text-cyan-500 px-2 py-1 max-sm:text-sm max-sm:mb-3">{tItem}</div>
            )})}
              </div>
              {/* <div className="text-gray-400">Summary</div>
              <div className="text-black">
                <p>
                  {item?.summary}
                </p>
              </div> */}
              
              <div className="pr-6 flex pl-4 mt-8 rounded-lg">
                <img
                  src={Logo}
                  alt="BotIcon"
                  className="mb-auto mr-2 w-10 h-10"
                />
                <div className="p-5 ml-4 !bg-[var(--brand-primary)] !w-full rounded-lg relative">
                  <Icon.CaretRightFill
                    className="left-icon-triangle-conversation"
                    style={{color:"var(--brand-primary)"}}
                  />
                  <p className="ai-heading text-white font-semibold">SIA Says</p>
                  <p className="ai-response !text-white">
                    {item?.relevance}
                  </p>
                </div>
              </div> 

              {<div className="mt-6">
            <div className="mb-2 text-gray-400">Talking Points</div>
           {/* {item?.action_items?.success_metrics?.length > 0 &&  <>
            <div className="list-decimal text-sm font-bold mb-1">
           B. Success Metrics
            </div>
            <div className="list-decimal text-sm ml-4">
            {item?.action_items?.success_metrics?.map((action) => {
            return (
              <li>{action}</li>
            )})}
            </div>
            </>} */}
            {item?.action_items?.clear_value_proposition?.length > 0 &&<>
            <div className="list-decimal text-sm font-bold mb-1">
           A. Value Proposition
            </div>
            <div className="list-decimal text-sm ml-4">
            {item?.action_items?.clear_value_proposition?.map((action) => {
            return (
              <li>{action}</li>
            )})}
            </div>
            </>}
            {item?.action_items?.tailored_outreach_strategy?.length > 0 && <>
            <div className="list-decimal text-sm font-bold mb-1">
           B. Outreach Strategy
            </div>
            <div className="list-decimal text-sm ml-4">
            {Array.isArray(item?.action_items?.tailored_outreach_strategy) ? item?.action_items?.tailored_outreach_strategy?.map((action) => {
            return (
              <li>{action}</li>
            )}):item?.action_items?.tailored_outreach_strategy}
            </div>
            </>}
        </div>}            
            </div>
          </main>
            )})}
           {messages?.is_writing && <div className='flex justify-center my-5'><svg
  class="containerNew"
  viewBox="0 0 40 40"
  height="40"
  width="40"
>
  <circle 
    class="track"
    cx="20" 
    cy="20" 
    r="17.5" 
    pathlength="100" 
    stroke-width="5px" 
    fill="#49BCD2" 
  />
  <circle 
    class="car"
    cx="20" 
    cy="20" 
    r="17.5" 
    pathlength="100" 
    stroke-width="5px" 
    fill="#49BCD2" 
  />
           </svg></div>}
        </div>
        {/* {(isLoading  || repStatus?.report_status == "queued" || repStatus?.report_status == "processing") ? <div className="flex justify-center"><img src={Jump} className="w-48 h-48 mt-48 "/>
</div> :
      <>   
    {repData?.length > 0 ? 
    repData?.map((item) => {
            return (
      <div className=" mx-16 my-10 justify-center flex-col intentContainer bg-white shadow-lg rounded-lg pt-2 pb-10 px-8">
        <div className="flex justify-between w-full border-b-[2px] border-gray-200 border-solid">
          <div className="flex mt-5 mb-4">
            <div className="font-bold text-sm mr-5 my-auto cursor-pointer" title={item?.new_title}>
              {item?.new_title?.length > 50 ? `${item?.new_title?.slice(0,50)}...`:item?.new_title}
            </div>
            <div className="text-gray-400 font-semibold text-sm bg-gray-100 px-2 py-1 my-auto rounded-md" title={item?.triggers_its_relevant_to[0]}>
              {item?.triggers_its_relevant_to[0]?.length > 30 ? `${item?.triggers_its_relevant_to[0]?.slice(0,30)}...`:item?.triggers_its_relevant_to[0]}
            </div>
          </div>
          <div className="font-bold text-sm mr-5 my-auto">{formatDate(item?.date)}</div>
        </div>
        <div className="w-full text-base mt-8">
          {item?.summary}
        </div>
        <div className="w-full text-base mt-1 text-gray-800 cursor-default">
          Source: <span title={item?.source} onClick={()=>{window.open(item?.source, '_blank')}} className="italic cursor-pointer">{item?.source?.length > 40 ? `${item?.source?.slice(0,40)}...`:item?.source}</span> 
        </div>
        <div className="mt-6 border-solid border-[2px] rounded-md border-[#757575] bg-gray-100 py-4 px-2 text-base">
          <div className="mb-6 font-bold">
            Relevancy:<span className={` capitalize ${categorizeScore(item?.relevance_score) == "high" ? "text-green-500":categorizeScore(item?.relevance_score) == "medium" ? "text-[#FF9500]" : "text-red-500"}`}> {categorizeScore(item?.relevance_score)}</span>
          </div>
          <div>
            {item?.relevance}
          </div>
        </div>
        {item?.action_items?.length > 0 && <div className="mt-6 text-base">
            <div className="mb-6 font-bold">Suggested Actions:</div>
            <div className="list-decimal">
              {item?.action_items?.map((action) => {
            return (
              <li>{action}</li>
            )})}
            </div>
        </div>}
      </div>
            )}) :
            <div className="flex justify-center mt-48 text-xl text-gray-800">Fill the Data to generate the report</div>
          }
      </>} */}
      </div>}
      {sidebarToggle == "Tracking" && <div className="pt-20 w-[80%] bg-[#f3f4f6] overflow-y-auto h-[99vh] px-20">
        <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
          <div className="text-lg leading-7 font-[500] my-auto">Intel Setup</div>
          <div className="flex">
          <div className="">
            <button
              type="button"
              className="mr-4 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
              onClick={()=>{setEditState(true)}}
            >
              Edit
            </button>
          </div>
          <div className="">
            <button
              type="button"
              className="mr-4 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
              onClick={()=>{handleSaveIntel();setEditState(false)}}
            >
              Save
            </button>
          </div>
          </div>
        </div>
        <div>
        
          <main className="px-4 py-2 space-y-4 !w-full">
          {pError?.length > 0 && <div className="text-sm text-red-500 leading-7 font-[500] my-auto cursor-default">{pError} Please upgrade <span onClick={()=>{navigate(`/Setting/billing`)}} className="cursor-pointer underline">here</span> to increase this cap</div>}
          {tData && tData?.data?.length > 0 && <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
              <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                Triggers
              </label>
              {/* <div className="flex-col">
                <div className="flex-wrap flex my-3">
                       {calendarTrigger && calendarTrigger?.map((item, index) => (
                      <div key={index} className="mr-2 my-auto mb-1 flex rounded-md bg-gray-300 p-1 text-xs">{item}<span onClick={()=>handleClose(index)} className="my-auto cursor-pointer"><IoClose/></span></div>
                       ))}
                       </div>
                       <hr className="mb-4"></hr>
                <input
                  type="text"
                  // name="triggers"
                  value={triggerValue}
                  onChange={(event)=>handleTrigger(event)}
                  onKeyDown={(event)=>handleKeyDown(event)}
                  className="block mx-2 mb-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter trigger and press Enter key"
                />
              </div> */}
              {tData?.data?.length > 0  && <MultiSelect
        options={tData?.data}
        value={selectedTrigger}
        onChange={handleTriggerChange}
        labelledBy="Select"
        className='w-full mt-2 !border-0'
        hasSelectAll={false}
      />}
            </div>}
            <div className="grid gap-x-8 grid-cols-12">
              <div className="col-span-6 bg-white px-3 shadow-sm ring-1 ring-inset ring-gray-300 rounded-md">
            <div className="text-sm text-black font-[500] my-4">Followed Companies</div>
              <div className="overflow-y-auto h-[25vh] removeScroll">
                {fList?.details?.company?.map((item, index) => {
                  return (
                    <div className="flex mb-4">
                      <img className="w-7 h-7 my-auto text-base" src={item?.logo ?? Logo} />
                      <div className="my-auto ml-3">{item?.company_website}</div>
                      {item?.follow && <FaStar
                        className={`text-blue-400 my-auto text-xs cursor-pointer ml-2`}
                      />}
                      {<div  onClick={()=>{handleunfollow(item?.id,"company")}} className="flex ml-auto my-auto mr-[1px] cursor-pointer text-xs font-bold">Unfollow</div>}
                    </div>
                  );
                })}
              </div>
              </div>
              <div className="col-span-6 bg-white px-3 shadow-sm ring-1 ring-inset ring-gray-300 rounded-md">
              <div className="text-sm text-black font-[500] my-4">Followed Industries</div>
            <div className="overflow-y-auto h-[25vh] removeScroll">
              {fList?.details?.industry?.map((item, index) => {
                return (
                  <div className="flex mb-4">
                    <img className="w-7 h-7 my-auto text-base" src={item?.logo ?? Logo} />
                    <div className="my-auto ml-3 font-[500]">
                      {item?.industry}
                    </div>
                    {/* {item?.follow && <FaStar className={`text-blue-400 my-auto text-xs cursor-pointer ml-2`}/>} */}
                      { <div  onClick={()=>{handleunfollow(item?.industry,"industry")}} className="flex ml-auto my-auto mr-[1px] cursor-pointer text-xs font-bold">Unfollow</div>}
                  </div>
                );
              })}
            </div>
              </div>
            </div>
            <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
              <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                About the Client
              </label>
              <div className="flex">
                <input
                  type="text"
                  name="aboutSeller"
                  value={aboutClient}
                  onChange={(e)=>{setAboutClient(e.target.value)}}
                  className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter Text Here"
                />
              </div>
            </div>
            <div className="rounded-md bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
              <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                Products/Offering
              </label>
              <div className="flex">
                <textarea
                  type="text"
                  name="aboutOffering"
                  value={productOffering}
                  onChange={(e)=>{setProductOffering(e.target.value)}}
                  className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter Text Here"
                />
              </div>
            </div>
            <div className="rounded-md cursor-default bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
              <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                Solutions
              </label>
              {editState && <div className="flex">
                <textarea
                  type="text"
                  name="aboutOffering"
                  value={compSolution}
                  onChange={(e)=>{setCompSolution(e.target.value)}}
                  className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter Text Here"
                />
              </div>}
              {!editState && <div className="list-item ml-5">
                {tList?.details?.competency_profile?.data?.solutions.map((item)=>(
                  <div className="list-item">
                  {item}
                  </div>
                ))}
              </div>}
            </div>
            <div className="rounded-md cursor-default bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
              <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                Products
              </label>
              {editState && <div className="flex">
                <textarea
                  type="text"
                  name="aboutOffering"
                  value={compProducts}
                  onChange={(e)=>{setCompProducts(e.target.value)}}
                  className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter Text Here"
                />
              </div>}
              {!editState && <div className="list-item ml-5">
                {tList?.details?.competency_profile?.data?.products.map((item)=>(
                  <div className="list-item">
                  {item}
                  </div>
                ))}
              </div>}
            </div>
            <div className="rounded-md cursor-default bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
              <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                Certification and Awards
              </label>
              {editState && <div className="flex">
                <textarea
                  type="text"
                  name="aboutOffering"
                  value={compCertificates}
                  onChange={(e)=>{setCompCertificates(e.target.value)}}
                  className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter Text Here"
                />
              </div>}
              {!editState && <div className="list-item ml-5">
                {tList?.details?.competency_profile?.data?.certification_and_awards.map((item)=>(
                  <div className="list-item">
                  {item}
                  </div>
                ))}
              </div>}
            </div>
            <div className="rounded-md cursor-default bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
              <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                Clients Case Studies
              </label>
              {editState && <div className="flex">
                <textarea
                  type="text"
                  name="aboutOffering"
                  value={compCase}
                  onChange={(e)=>{setCompCase(e.target.value)}}
                  className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter Text Here"
                />
              </div>}
              {!editState && <div className="list-item ml-5">
                {tList?.details?.competency_profile?.data?.clients_case_studies?.map((item)=>(
                  <div className="list-item">
                  {item}
                  </div>
                ))}
              </div>}
            </div>
            <div className="rounded-md cursor-default bg-white mb-2 px-3 mt-2 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 w-full">
              <label
                htmlFor="name"
                className="block text-sm text-black font-[500]"
              >
                Focus Industries
              </label>
              {editState && <div className="flex">
                <textarea
                  type="text"
                  name="aboutOffering"
                  value={compFocus}
                  onChange={(e)=>{setCompFocus(e.target.value)}}
                  className="block mr-2 w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter Text Here"
                />
              </div>}
              {!editState && <div className="list-item ml-5">
                {tList?.details?.competency_profile?.data?.focus_industries?.map((item)=>(
                  <div className="list-item">
                  {item}
                  </div>
                ))}
              </div>}
            </div>

            
           
          </main>
        </div>
        
      </div>}
    </div>
  );
};

export default IntelSetting;
